const LINK_IT_FRAGMENT = `
  url
  text
  target
`

export default LINK_IT_FRAGMENT
